import script from "./ProfilInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilInfo.vue?vue&type=script&setup=true&lang=js"

import "./ProfilInfo.vue?vue&type=style&index=0&id=3213cb65&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3213cb65"]])

export default __exports__